import {createRouter, createWebHistory} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ContactView from "@/views/ContactView.vue";
import PortfolioView from "@/views/PortfolioView.vue";
import ArticlesView from "@/views/ArticlesView.vue";
import ArticleView from "@/views/ArticleView.vue";
import ShowcaseWebsiteView from "@/views/ShowcaseWebsiteView.vue";
import LemonManagerView from "@/views/LemonManagerView.vue";
import FeatureView from "@/views/FeatureView.vue";
import SoftwareView from "@/views/SoftwareView.vue";
import LegalView from "@/views/LegalView.vue";
import NotFoundView from "@/views/NotFoundView.vue";
import articles from "@/content/articles";
import features from "@/content/features";

// Les adresses ci-dessous sont aussi dans src/content/pages.js (titres, descriptions, sitemap) : en ajouter une ici impose de l'y ajouter.
const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/gestionnaire-citron',
    name: 'LemonManagerView',
    component: LemonManagerView
  },
  // Une route par page de fonction
  ...features.map(feature => ({
    path: `/gestionnaire-citron/${feature.slug}`,
    name: `Feature-${feature.slug}`,
    component: FeatureView,
    props: {slug: feature.slug}
  })),
  {
    path: '/blog',
    name: 'Blog',
    component: ArticlesView
  },
  // Une route par article, pour la même raison
  ...articles.map(article => ({
    path: article.path,
    name: `Article-${article.slug}`,
    component: ArticleView,
    props: {slug: article.slug}
  })),
  {
    path: '/site-web',
    name: 'ShowcaseWebsiteView',
    component: ShowcaseWebsiteView
  },
  {
    path: '/logiciel',
    name: 'SoftwareView',
    component: SoftwareView
  },
  {
    path: '/portfolio',
    name: 'Portfolio',
    component: PortfolioView
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactView
  },
  {
    path: '/mentions-legales',
    name: 'Legal',
    component: LegalView
  },
  // L'ancienne page vide « articles » devient le blog
  {
    path: '/articles',
    redirect: '/blog'
  },
  // Toute autre adresse : page d'erreur non indexée (et non plus l'accueil, qui dupliquait son contenu à l'infini)
  {
    path: "/:catchAll(.*)",
    name: 'NotFound',
    component: NotFoundView
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior: function(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) return { el: to.hash, top: 80, behavior: 'smooth' };
    return { top: 0, left: 0 };
  },
});

export default router
